const getConfig = (root, kind = 'config') => {
    const selector = `script[data-kind="${kind}"][type="application/json"]`;
    return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
}

const eventPrefix = `seven:checkout:product`; // keep lowercase!

Alpine.data('SevenCRMCheckoutProduct', (element) => ({
    lastSale: 'n/a',
    selected: false,
    config: getConfig(element).at(-1),

    init() {
        if (element.closest('[data-index]')) {
            const currentIndex = element.closest('[data-index]').dataset.index;
            const lastSale = this.config.lastSale[currentIndex];

            this.lastSale = lastSale?.label?.replace('{0}', this._getRandomInteger(...lastSale.value)) ?? 'n/a';
        }

        window.addEventListener(`${eventPrefix}:selected`, this._onProductSelected.bind(this));
        element.addEventListener('click', this.select.bind(this));
        if (this.config.preSelected) this.select();
    },

    select(e) {
        this.selected = true;
        requestAnimationFrame(() => {
            element.dispatchEvent(new CustomEvent(`${eventPrefix}:selected`, {
                detail: {
                    source: e ? 'manual' : 'initial',
                    ...this.config
                },
                bubbles: true,
                cancelable: false,
            }))
        });
    },

    _onProductSelected(e) {
        this.selected = e.detail.id === this.config.id;
    },

    _getRandomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
}));
